import styled from '@emotion/styled';
import { colors } from '~/styles/constants';

const FormError = styled('div')`
  margin-top: 5px;
  font-size: 12px;
  color: ${colors.dangerRed};
`;

export default FormError;
